import React, { useState } from "react";
import { Modal, Form, Input, Button, App } from "antd";
import {
  EyeOutlined,
  EyeInvisibleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import http from "../../services/http";

const ChangePasswordModal = ({ visible, onClose }) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      if (values.newPassword !== values.confirmPassword) {
        message.error("Mật khẩu mới và mật khẩu xác nhận không khớp nhau");
        return;
      }

      setLoading(true);
      
      await http.post("/auth/change-password", {
        oldPassword: values.currentPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });

      message.success("Mật khẩu đã được thay đổi thành công");
      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Error changing password:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={460}
      closeIcon={<CloseOutlined />}
      className="change-password-modal"
      centered
    >
      <h2 className="text-xl font-semibold text-gray-900 text-center mb-6">
        Thay đổi mật khẩu
      </h2>

      <Form form={form} layout="vertical">
        <Form.Item
          label={
            <span className="text-sm text-gray-700">
              Nhập mật khẩu hiện tại của bạn
            </span>
          }
          name="currentPassword"
          rules={[{ required: true, message: "Vui lòng nhập mật khẩu hiện tại" }]}
        >
          <Input.Password
            placeholder="Nhập mật khẩu hiện tại của bạn"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          label={
            <span className="text-sm text-gray-700">Tạo mật khẩu mới</span>
          }
          name="newPassword"
          rules={[
            { required: true, message: "Vui lòng nhập mật khẩu mới" },
            { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự" },
          ]}
        >
          <Input.Password
            placeholder="Tạo mật khẩu mới"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Form.Item
          label={
            <span className="text-sm text-gray-700">
              Xác nhận mật khẩu mới của bạn
            </span>
          }
          name="confirmPassword"
          rules={[
            { required: true, message: "Vui lòng xác nhận mật khẩu của bạn" },
            { min: 8, message: "Mật khẩu phải có ít nhất 8 ký tự" },
          ]}
        >
          <Input.Password
            placeholder="Xác nhận mật khẩu mới của bạn"
            iconRender={(visible) =>
              visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          />
        </Form.Item>

        <Button
          type="primary"
          block
          size="large"
          onClick={handleSubmit}
          loading={loading}
          className="bg-purple-600 hover:bg-purple-700 border-0 mt-4"
        >
          Lưu thay đổi
        </Button>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
